// Логиката на подсказките в „Причина" (без React): думите на търсенето,
// филтърът и „вече съществуващата" причина. Търсенето е като голямата
// търсачка на листа — многодумно, без значение на малки/главни букви: всяка
// дума трябва да се среща някъде в причината.
import {
  writeoffReasonKey,
  type WriteoffReason,
} from "../../../../api/inventoryWriteoffReasons";

// Думите на текста в полето (малки букви) — и за филтъра, и за оцветяването
export const reasonSearchWords = (text: string): string[] =>
  text.trim().toLowerCase().split(/\s+/).filter(Boolean);

// Празно поле → всички (редът е на BE: най-ползваните първи); иначе — тези,
// които съдържат всяка дума. Редът се пази и при филтъра.
export const filterReasonSuggestions = (
  reasons: WriteoffReason[],
  text: string,
): WriteoffReason[] => {
  const words = reasonSearchWords(text);
  if (!words.length) return reasons;
  return reasons.filter((item) => {
    const haystack = item.reason.toLowerCase();
    return words.every((word) => haystack.includes(word));
  });
};

// Написаното съвпада с вече ползвана причина (без значение на малки/главни
// букви и интервали) → изписването ѝ, за да остане ЕДНА причина във филтъра
// на справката; иначе null.
export const findExistingReason = (
  reasons: WriteoffReason[],
  text: string,
): string | null => {
  const key = writeoffReasonKey(text);
  if (!key) return null;
  return reasons.find((item) => writeoffReasonKey(item.reason) === key)?.reason ?? null;
};
